import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { List } from 'immutable';
import { ResponsiveLayout } from '@comparethemarketau/manor-layout';

import { ProductCardLg } from './product_card/product_card_lg';
import { ProductCardMd } from './product_card/product_card_md';
import { ProductCardSm } from './product_card/product_card_sm';
import { ProductCardXs } from './product_card/product_card_xs';

import { withAvailableQuotes } from './common/with_available_quotes';
import { ContainerWrapper } from '../container_wrapper';

const _PolicyProducts = (props) => {
    const { availableQuotes, padding, availableQuotesSize } = props;

    return (
        availableQuotesSize > 0 && (
            <ContainerWrapper padding={padding} className={classNames('test-policyProducts')}>
                {
                    availableQuotes && availableQuotes.map((quote, index) => {
                        const productId = quote.get('productMeta').get('id');
                        return (
                            <div key={`product-${productId}`} id={`result-row-${index}`} data-product-id={productId}>
                                <ResponsiveLayout is={'xs'}><ProductCardXs quote={quote} index={index} size={availableQuotes.size} /></ResponsiveLayout>
                                <ResponsiveLayout is={'sm'}><ProductCardSm quote={quote} index={index} /></ResponsiveLayout>
                                <ResponsiveLayout is={'md'}><ProductCardMd quote={quote} index={index} /></ResponsiveLayout>
                                <ResponsiveLayout isFrom={'lg'}><ProductCardLg quote={quote} index={index} /></ResponsiveLayout>
                            </div>
                        );
                    })
                }
            </ContainerWrapper>
        )
    );
};

_PolicyProducts.propTypes = {
    availableQuotes: PropTypes.instanceOf(List),
    availableQuotesSize: PropTypes.number,
    padding: PropTypes.array
};

const PolicyProducts = withAvailableQuotes(_PolicyProducts);

export { PolicyProducts, _PolicyProducts };
